import { inject, Injectable } from '@angular/core';
import { PhoneService } from '@services/phone.service';
import { QueryParamsService } from '@services/query-params.service';

@Injectable({
  providedIn: 'root',
})
export class ScheduleOnceService {
  private readonly queryParamsService = inject(QueryParamsService);
  private readonly phoneService = inject(PhoneService);

  /**
   * Builds the schedule consultation URL with the necessary query params.
   *
   * @param {string} consultationId the consultation request id
   * @param {string} scheduleOnceId the schedule once id
   * @param {string} orderId the order id
   * @param {string} hash the order hash
   * @param {string} phone the phone number
   *
   * @returns {string} the URL with the query params
   */
  public getScheduleConsultationUrl(
    consultationId: string,
    scheduleOnceId: string,
    orderId: string,
    hash: string,
    phone: string,
  ): string {
    return this.queryParamsService.bindQueryParamsToUrl('/consultation/schedule-consultation', {
      order_id: orderId,
      hash: hash,
      consultationId: consultationId,
      scheduleOnceId: scheduleOnceId,
      contact: this.phoneService.formatPhoneNumber(phone),
    });
  }
}
